export const BLOCK_TRADE_REGISTRATION_FUTURES_PATH =
  '/block-trade-registration';
